import { z } from 'zod';
export const EventParticipantRoleSchema = z.enum(['PONENTE']);
export const EventParticipant = z.object({
    id: z.string().uuid(),
    eventId: z.string().uuid(),
    fullName: z.string(),
    email: z.string().email(),
    phone: z.string().nullable(),
    role: EventParticipantRoleSchema,
    bio: z.string().nullable(),
    shortCode: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const CreateEventParticipantInput = z.object({
    eventId: z.string().uuid().optional(),
    fullName: z.string().min(1, 'Nombre obligatorio'),
    email: z.string().email('Email inválido'),
    phone: z.string().optional(),
    role: EventParticipantRoleSchema.default('PONENTE'),
    bio: z.string().optional(),
});
export const UpdateEventParticipantInput = CreateEventParticipantInput.partial().omit({
    eventId: true,
});
export const ParticipantImportRow = z.object({
    nombre_completo: z.string().min(1),
    email: z.string().email(),
    telefono: z.string().optional(),
    bio: z.string().optional(),
});
export const ParticipantImportResult = z.object({
    total: z.number(),
    created: z.number(),
    skipped: z.number(),
    errors: z.array(z.object({ row: z.number(), reason: z.string(), data: z.record(z.unknown()).optional() })),
});
export const ParticipantsListQuery = z.object({
    eventId: z.string().uuid().optional(),
});
/** `GET /api/participants` responde un arreglo directo en `data` (sin paginacion). */
export const ParticipantsListResponse = z.array(EventParticipant);
export const ParticipantBroadcastRequest = z.object({
    messageType: z.literal('SPEAKER_CERTIFICATE'),
    channel: z.literal('email'),
    filter: z.object({
        eventId: z.string().uuid(),
        onlyPending: z.boolean().default(true),
    }),
});
//# sourceMappingURL=event-participant.js.map